import { AppActions, BillingStatusRes } from "../types";
import { generateSignedRequestConfig, getBaseUrl } from ".";

// Custom Billing Status API function to retrieve data needed by the Login screen to determine if the user should be redirected or not.
// Created as useGetBillingStatus would return as idle no matter what scope/method of calling was done after the useMutation call done for the base login API, or work sometimes and then error out.
// Maybe this was just caused by lack of knowledge of react-query and React hooks and there's a way of getting it to work, but after like 6+ hours of trying to get it to work
// I gave up and wrote my own little simple class. It works fine and does the job and is typed correctly unlike anything else in this app 
// so whatever i dont care anymore sorry

async function getBillingStatusQueryless ( dispatch: (action: AppActions) => void, errorText: string, userData: {apiKey: string, apiSecret: string, countryCode: string, id: string} ) {
  const { apiKey, apiSecret, countryCode, id } = userData;

  const config = await generateSignedRequestConfig({
    apiKey,
    apiSecret,
    countryCode,
    id,
    method: 'GET',
    url: `${getBaseUrl()}/api/billing/user/${id}/billingStatus`,
  });

  try {

    const response = await fetch(config.url, { ...config })

    const data = await response.json() as BillingStatusRes;

    dispatch({
        type: 'UPDATE_BILLING_STATUS',
        payload: {
          ...data,
        },
    });

    return data;
  } 
  catch (error: any) {
    console.error('Error getting billing status: ', error);
    dispatch({
      type: 'ADD_MESSAGE',
      payload: {
        dismissable: true,
        id: new Date().getTime(),
        text: errorText,
        timeout: 7,
        type: 'error',
      },
    });

    return null;
  }
}


export default getBillingStatusQueryless;